import BuildIcon from '@mui/icons-material/Build'
import { ServiceCentersViewSelect } from 'feature/serviceCenters/components'
import { useGetServicesQuery } from 'feature/serviceCenters/redux/service.api'
import { SetPageTypeProps } from 'feature/serviceCenters/types'
import { useSetNotice } from 'hooks/useSetNotice'
import { useEffect } from 'react'
import { Loading } from 'router/Loading'
import { Severity, useNotification } from 'widget/Notifications'

import style from './ServiceCentersMainView.module.scss'

// основная страница сц
export function ServiceCentersMainView({ setPageType }: SetPageTypeProps) {
  const { data, isLoading, isError } = useGetServicesQuery()
  const notifications = useNotification()
  const setNotice = useSetNotice()

  useEffect(() => {
    if (isError && !notifications?.length) {
      setNotice('Ошибка загрузки данных', Severity.error)
    }
  }, [isError])

  return (
    <section className={style.ServiceCenters}>
      <h1 className={style.serviceTitle}>
        <BuildIcon />
        Сервисные центры
      </h1>

      {data && !isLoading && (
        <ServiceCentersViewSelect
          data={data}
          setPageType={setPageType}
          isLoading={isLoading}
        />
      )}

      {isLoading && !data && <Loading />}
    </section>
  )
}
